import React from 'react';
import { Box, Typography } from '@mui/material';
import CommentCard from './CommentCard';

const CommentColumn = ({
    side,
    comments,
    activeComment,
    hoveredComment,
    onCommentClick,
    onCommentHover,
    onCommentLeave,
    colors,
}) => {
    const isLeft = side === 'left';
    const title = isLeft ? 'Areas for Improvement' : 'Strengths';
    const titleColor = isLeft ? colors.redAccent[400] : colors.blueAccent[400];

    return (
        <Box>
            <Typography
                variant="subtitle1"
                fontWeight="bold"
                mb={2}
                color={titleColor}
                textAlign={isLeft ? 'right' : 'left'}
            >
                {title} ({comments.length})
            </Typography>

            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                {comments.map((comment) => (
                    <CommentCard
                        key={comment.id}
                        id={`comment-${comment.id}`}
                        item={comment.data}
                        type={comment.type}
                        isActive={activeComment === comment.id}
                        isHovered={hoveredComment === comment.id}
                        onClick={() => onCommentClick(comment.id)}
                        onMouseEnter={() => onCommentHover(comment.id)}
                        onMouseLeave={onCommentLeave}
                        colors={colors}
                    />
                ))}
            </Box>
        </Box>
    );
};

export default CommentColumn;
